import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, Alert, Row, Col, message, Select } from 'antd';
import Ink from 'react-ink';
import { yearFrom, yearTo } from './../../../config';

import {
  schoolquotaInsert,
  schoolquotaUpdate,
} from '../../../modules/schoolquota';
import {
  schoolList
} from '../../../modules/school';

const FormItem = Form.Item;
const { Option } = Select;

class SchoolQuotaDetails extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
			message: null,
      schoolList: null,
		}
    this.yearList = [];
    for (let i = yearFrom; i <= yearTo; i++) {
      this.yearList.push(`${i} - ${i+1}`);
    }
	}

  componentDidMount = () => {
    if (!this.props.schoolListData) {
      this.getSchoolList();
    } else {
      this.setState({schoolList: this.props.schoolListData});
    }
  }
	
	handleSubmit = e => {
		e.preventDefault();

		const { data } = this.props;

		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ loading: true });

				if (!this.props.data) {
					this.props.schoolquotaInsert(values).then( 
						(res) => {
							message.success('成功新增學校限額!');
							this.setState({ loading: false, message: null });
							this.props.form.resetFields();
							this.props.callback();
						},
						(err) => {
							this.setState({ loading: false, message: err.response && err.response.data && err.response.data.message ? err.response.data.message : '新增失敗，請重新載入後重試。' });
						}
					);
				}
				else {

        if (parseInt(values.quota, 10) < data.generated) {
          this.setState({ loading: false, message: `限額不能少於已產生的學生數量。` }); 
          return;
        }
				
				this.props.schoolquotaUpdate(values, data._id).then( 
					(res) => {
						message.success('成功編輯學校限額!');
						this.setState({ loading: false, message: null });
						this.props.callback();
					},
					(err) => {
						this.setState({ loading: false, message: err.response && err.response.data && err.response.data.message ? err.response.data.message : '更新失敗，請重新載入後重試。' });
					}
				);
			}
			}
		});
	}

  getSchoolList = () => {
    this.props.schoolList().then((res) => {
      this.setState({schoolList: res});
    })
  }

  constructSchoolOptions = () => {
    const { schoolList } = this.state;
    if (schoolList) {
      return schoolList.results.map((item, i) => <Option value={item._id}>{item.name_tc || item.name_en}</Option>);
    }
  }

  constructYearOptions = () => {
    return this.yearList.map((item, i) => <Option value={item}>{item}</Option>);
  }

	render() {
		
		const { loading, message } = this.state;
		const { getFieldDecorator } = this.props.form;

		const { data } = this.props;
		
		return (
			<Form onSubmit={this.handleSubmit} className="ownForm">
				{ (message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}

        <FormItem
					label="學校"
				>
					{ getFieldDecorator('schoolId', {
						rules: [ { required: true, message: '請選擇學校！' } ],
						initialValue: (data && data.schoolId) ? data.schoolId : "",
					})(
					  <Select disabled={data && data.schoolId}>
            {
              this.constructSchoolOptions()
            }
            </Select>
					)}
				</FormItem>

				<FormItem
					label="年度"
				>
					{ getFieldDecorator('year', {
						rules: [ { required: true, message: '請輸入年度！' } ],
						initialValue: (data && data.year) ? data.year : "",
					})(
            <Select disabled={data && data.year}>
            {
              this.constructYearOptions()
            }
            </Select>
					)}
				</FormItem>

        <FormItem
					label="限額"
				>
					{ getFieldDecorator('quota', {
						rules: [ { required: true, message: '請輸入限額！' } ],
						initialValue: (data && data.quota) ? data.quota : ""
					})(
					<Input />
					)}
				</FormItem>

				<FormItem 
					className="noMarginBtm"
				>
					<Button type="primary" htmlType="submit" disabled={loading} style={{ width: '100%' }}><Ink /><Icon type="arrow-right" /> 提交</Button>
				</FormItem>
			</Form>
		);
	}
}

const WrappedSchoolQuotaDetailsModal  = Form.create()(SchoolQuotaDetails);

const mapStateToProps = state => ({
  schoolListData: state.school.data,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		schoolquotaInsert,
		schoolquotaUpdate,
    schoolList,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedSchoolQuotaDetailsModal);
